import { FC, ReactNode } from 'react';

import FilterAltIcon from '@mui/icons-material/FilterAlt';
import IconButton from '@mui/material/IconButton';
import Stack from '@mui/material/Stack';
import {
  GridColDef,
  GridFilterItem,
  GridRenderCellParams,
  GridValidRowModel,
  gridFilterModelSelector,
  useGridApiContext,
} from '@mui/x-data-grid-pro';

type CellWrapperProps = {
  currentCellParams: GridRenderCellParams<GridValidRowModel>;
  originColumn: GridColDef<GridValidRowModel>;
};

const CellWrapper: FC<CellWrapperProps> = ({
  currentCellParams,
  originColumn,
}) => {
  const apiRef = useGridApiContext();
  const filterModel = gridFilterModelSelector(apiRef.current.state);

  const cellContent = originColumn.renderCell
    ? originColumn.renderCell(currentCellParams)
    : (currentCellParams.row[currentCellParams.field] as ReactNode);

  const isButtonVisible =
    (typeof cellContent === 'string' && cellContent.trim() !== '') ||
    (typeof cellContent !== 'string' &&
      cellContent !== null &&
      cellContent !== undefined);

  const handleFilterModelUpdate = (inputValue: string) => {
    let newFilterItems: GridFilterItem[];

    const filter = filterModel.items.find(
      (item) => item.field === currentCellParams.field,
    );

    if (filter) {
      newFilterItems = filterModel.items.map((item) =>
        item.field === currentCellParams.field
          ? { ...item, value: inputValue }
          : item,
      );
    } else {
      newFilterItems = [
        ...filterModel.items,
        {
          id: currentCellParams.field,
          field: currentCellParams.field,
          operator: 'ilike',
          value: inputValue,
        },
      ];
    }

    if (!inputValue) {
      newFilterItems = newFilterItems.filter(
        (item) => item.field !== currentCellParams.field,
      );
    }

    apiRef.current.setFilterModel({
      ...filterModel,
      items: newFilterItems,
    });
  };

  return (
    <Stack
      sx={{
        'display': 'flex',
        'flexDirection': 'row',
        'alignItems': 'center',
        'gap': 2,
        'height': '100%',
        'width': '100%',
        'pl': 1,

        '&:hover': {
          '.filter-button': {
            opacity: 1,
          },
        },
      }}
    >
      {cellContent}

      {isButtonVisible && currentCellParams.colDef.filterable && (
        <IconButton
          size='small'
          className='filter-button'
          sx={{ opacity: 0, transition: 'opacity 0.3s' }}
          onClick={() =>
            handleFilterModelUpdate(
              currentCellParams.row[currentCellParams.field] as string,
            )
          }
        >
          <FilterAltIcon sx={{ width: 16, height: 16 }} />
        </IconButton>
      )}
    </Stack>
  );
};

export default CellWrapper;
